<template>
  <WsRead
    ref="WsRead"
    localeMode
    itemVersionCreatable
    titleKey="last_version.name"
    editBtnText="鑑別人員與法規內容"
    :label="label"
    :fields="fields"
    :editable="false"
    :deletable="false"
    :fetchUrl="_fetchUrl"
    :modelName="modelName"
    :id="$route.params.id"
    :itemDeletable="false"
    :multiUrl="$_getMultiUrl"
    :customBtns="_customBtns"
    :itemLinkCheckable="false"
    :itemEditable="!_isStageFinished"
    :primary="_pageSetting.primary"
    :secondary="_pageSetting.secondary"
    :modelVersionName="modelVersionName"
    @input="$_getModelData($event)"
    @goToReview="$_onGoToReview(modelData)"
    @delete-article="$_onSetAlert('deleteArticle', $event)"
    @go-to-related-template="$_onGoToRelatedTemplate(modelData)"
  >
    <WsAlertDialog
      ref="alertPopup"
      :title="alertPopup.title"
      :description="alertPopup.description"
      :btnText="alertPopup.btnText"
      :color="alertPopup.color"
      @submit="$_onSubmitAlertPopup"
    />
  </WsRead>
</template>

<script>
import model from '@/models/act_cnt_review';
import submodel from '@/models/article';
import idtfModel from '@/models/act_idtf_assignment';
import H_act from '@/helpers/act';
import H_idtf from '@/helpers/idtf';
import Spare_act from '@/spare/act';

export default {
  data() {
    return {
      modelName: model.modelName,
      modelVersionName: model.versionModelName,
      label: model.label,
      fields: idtfModel.fields,
      modelData: null,
      originArticleVerIdList: [],
      alertPopup: {
        type: '',
        title: '',
        description: '',
        btnText: '',
        color: '',
        data: null,
      },
    };
  },
  methods: {
    async $_getModelData($event) {
      this.modelData = $event;
      await this.$_getAllArticleVersionIds();
    },
    $_onGoToRelatedTemplate(modelData) {
      this.$router.push(
        `/act/${modelData.act_version.act.id}/relatedtemplate/${modelData.act_version.id}`,
      );
    },
    $_onGoToReview() {
      this.$router.push(`/act_cnt_review/${this.$route.params.id}/review`);
    },
    $_getMultiUrl(modelData) {
      if (!modelData) return [];
      return [`/act/${modelData.act_version.act.id}`, `/act_version/${modelData.act_version.id}`];
    },
    $_setArticleUpdateData(updateData, fetchValue, editType) {
      const {
        no_number,
        act_status,
        announce_at,
        effect_at,
        attaches,
        reference_link,
        locales,
        effects,
        is_active,
      } = updateData;
      const {
        article: {
          id: articleId,
          act_version: {
            act: { id: actId },
          },
        },
        sequence,
      } = fetchValue;
      const baseData = {
        sequence,
        no_number,
        article: articleId,
        act_status,
        announce_at,
        effect_at,
        attaches,
        reference_link,
        locales,
        effects,
        is_active,
      };
      if (editType === 'createVersion') {
        return {
          ...baseData,
          act: actId,
          act_version: this.modelData.last_version.id,
          act_versions: [this.modelData.last_version.id],
        };
      } else return baseData;
    },
    async $_storeArticleVersionAndIdtfItem(postData) {
      try {
        const res = await this.$axios.post('/article_version/store/with_idtf', postData);
        return res.data.data;
      } catch (error) {
        alert(error);
      }
    },
    async $_updateActVersion(originArticleVerId, newArticleVerId) {
      const newArticleVerIdList = this.originArticleVerIdList.filter(
        (id) => id !== originArticleVerId,
      );
      newArticleVerIdList.push(newArticleVerId);
      await this.$axios.patch(`/act_version/${this.modelData.last_version.id}`, {
        article_versions: newArticleVerIdList,
      });
    },
    async $_updateArticleVersion(updateData, fetchValue, editType) {
      const postData = this.$_setArticleUpdateData(updateData, fetchValue, editType);
      try {
        await this.$axios.patch(`/article_version/${fetchValue.id}`, postData);
      } catch (error) {
        alert(error);
      }
    },
    async $_getAllArticleVersionIds() {
      const res = await this.$axios.get('article_version/id/index/all', {
        params: {
          get_all: 1,
          act_versions: this.modelData.last_version.id,
        },
      });
      this.originArticleVerIdList = res.data.data.map((articleVer) => articleVer.id);
    },
    async $_createArticle(createData) {
      let postData = {
        ...JSON.parse(JSON.stringify(createData)),
        act: this.modelData.act.id,
        act_version: this.modelData.last_version.id,
        act_versions: [this.modelData.last_version.id],
      };
      const res = await this.$axios.post(
        `act_version/${this.modelData.last_version.id}/article/store/with_idtf`,
        postData,
      );
      return res.data.data;
    },
    async $_onUnbindArticleVerFromAct($event) {
      const { item, parentId, itemId: articleVerId } = $event;
      const isArticleCreatedInCurrentVersion = H_act.isArticleCreatedInCurrentVersion(
        item,
        this.modelData,
      );
      try {
        if (isArticleCreatedInCurrentVersion) {
          await this.$axios.delete(`article_version/${articleVerId}`);
        } else {
          await this.$axios.post(`article_version/${articleVerId}/remove`, {
            act_versions: [parentId],
          });
          await this.$axios.delete(`act_idtf_assignment_item/${item.act_idtf_assignment_item.id}`);
        }
      } catch (error) {
        alert(error);
      }
    },
    $_onSubmitAlertPopup() {
      const type = this.alertPopup.type;
      const actionList = {
        deleteArticle: async () => {
          const alertPopup = this.$refs.alertPopup;
          alertPopup.startLoading();
          await this.$_onUnbindArticleVerFromAct(this.alertPopup.data);
          this.$refs.WsRead.$refs.WsReadContentBlock_primary_1[0].$refs.wsDataExpandList.$_onDelete(
            this.alertPopup.data.itemId,
          );
          alertPopup.stopLoading();
          alertPopup.close();
        },
      };
      actionList[type]();
    },
    $_onSetAlert(eventType, $event) {
      const actionList = {
        deleteArticle: () => {
          this.alertPopup = {
            ...Spare_act.alertInfo.deleteArticle,
            type: eventType,
            data: $event,
          };
          const { item } = $event;
          const isArticleCreatedInCurrentVersion = H_act.isArticleCreatedInCurrentVersion(
            item,
            this.modelData,
          );
          if (isArticleCreatedInCurrentVersion) {
            this.alertPopup.title = '確認要刪除此法條嗎？';
          } else {
            this.alertPopup.title = '確認要解除綁定此法條嗎？';
          }
        },
      };
      actionList[eventType]();
      this.$refs.alertPopup.open();
    },
  },
  computed: {
    _customBtns() {
      return H_idtf.setReadPageTopCustomBtns(this.modelData, this.modelName);
    },
    _fetchUrl() {
      return `/act_idtf_assignment/${this.$route.params.id}`;
    },
    _isStageFinished() {
      return H_idtf.isStageFinished(this.modelData, this.modelName);
    },
    _pageSetting() {
      return {
        primary: [
          {
            type: 'infoCard',
            hideOnNull: false,
            floors: [
              {
                fields: ['locales', 'announce_at', 'effect_at', 'reference_link', 'attaches'],
              },
            ],
          },
          {
            type: 'expandList',
            label: submodel.label,
            modelName: submodel.versionModelName,
            modeParent: true,
            modeVersions: true,
            modeParentVersions: true,
            fields: submodel.fields.last_version.fields,
            titleKey: 'no_text',
            fieldsRead: [
              'act_status',
              'locales',
              'announce_at',
              'effect_at',
              'attaches',
              'effects',
            ],
            batchMode: !this._isStageFinished,
            searchMode: false,
            orderBy: 'no_number',
            orderWay: 'asc',
            hideOnNull: false,
            isVersionAPI: true,
            itemCreatable: !this._isStageFinished,
            itemVersionReadableUrl: function (modelData) {
              return `/article/${modelData.article.id}/version`;
            },
            customUpdateSubmitAction: async (updateData, fetchValue, editType, modelData) => {
              try {
                if (editType === 'createVersion') {
                  if (!modelData.last_version.act_idtf_assignment) {
                    throw new Error('沒有建立法規鑑別，請先建立法規鑑別');
                  }
                  const { id: originArticleVerId } = fetchValue;
                  const versionData = this.$_setArticleUpdateData(updateData, fetchValue, editType);
                  const { id: newArticleVerId } = await this.$_storeArticleVersionAndIdtfItem(
                    versionData,
                  );
                  await this.$_updateActVersion(originArticleVerId, newArticleVerId);
                  return { oldId: originArticleVerId, newId: newArticleVerId };
                } else {
                  await this.$_updateArticleVersion(updateData, fetchValue, editType);
                  return { oldId: fetchValue.id, newId: fetchValue.id };
                }
              } catch (error) {
                console.log(error);
              }
            },
            defaultBtnDisplayFunc: (btnType, modelData, fetchValue) => {
              const btnDisplayList = {
                itemVersionCreatable: (modelData, fetchValue) => {
                  if (modelData.last_version.version_status !== 0) return false;
                  const currentActVersionId = modelData.id;
                  const articleVersionCreatedActVersionId = fetchValue.act_version
                    ? fetchValue.act_version.id
                    : null;
                  return currentActVersionId !== articleVersionCreatedActVersionId;
                },
              };
              return btnDisplayList[btnType](modelData, fetchValue);
            },
            customCreateSubmitAction: async (createData) => {
              try {
                const res = await this.$_createArticle(createData);
                return {
                  ...res.last_version,
                  article: {
                    id: res.id,
                  },
                  act_version: { id: this.modelData.last_version.id },
                };
              } catch (error) {
                console.log(error);
              }
            },
            shouldShowUpdateTag: (modelData, fetchValue) => {
              const currentActVersionId = modelData.id;
              const articleVersionCreatedActVersionId = fetchValue.act_version
                ? fetchValue.act_version.id
                : null;
              return currentActVersionId === articleVersionCreatedActVersionId;
            },
            batchLink: (modelData) => `/act_version/${modelData.id}/article/create/batch`,
            getUrl: () => 'article_version/index/light',
          },
        ],
        secondary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '設定',
                fields: [
                  'sequence',
                  'areas',
                  'act_type',
                  'industry_categories',
                  'system_classes',
                  'system_subclasses',
                  'range_type',
                  'factories',
                  'exclusive_factories',
                ],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '鑑別人員設定',
                fields: [
                  'overall_owners',
                  'km_owners',
                  'km_backups',
                  'km_reviewers',
                  'idtf_owners',
                  'idtf_backups',
                  'idtf_reviewers',
                ],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '法規內容格式更新作業狀態',
                fields: ['act_cnt_status', 'act_cnt_updated_admin', 'act_cnt_updated_at'],
              },
            ],
          },
        ],
      };
    },
  },
};
</script>
